module.exports = __webpack_public_path__ + "static/media/singing_class_routine.5801bccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/singing_class_routine.jpg
// module id = 1274
// module chunks = 0